import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL /clients/$clientId → redirect to /admin/clients/$clientId.
export const Route = createFileRoute("/clients/$clientId")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/admin/clients/$clientId", params: { clientId: params.clientId } });
  },
  component: () => null,
});
